export type StatusMapEntries<T extends string | number | symbol | boolean, U extends string> = [T, U][]

export const createStatusMap = <T extends string | number | symbol | boolean, U extends string>(
  entries: StatusMapEntries<T, U>
): Map<T, U> => {
  return new Map<T, U>(entries)
}
